import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { PropertyListingStateService } from '../../../../app/shared/services/sell-your-property/property-listing-state.service';
import { NotificationService } from '../../../../app/shared/services/notification-service/notification.service';
import { MapStateCheckService } from '../../../../app/shared/services/map-state-check/map-state-check.service';
import { SellMyPropertyService } from '../../../../app/services/property-matrixV2/services';
import { GlobalMethods } from '../../../../app/common/global-methods';

@Component({
  selector: 'app-property-listing-steps',
  templateUrl: './property-listing-steps.component.html',
  styleUrls: ['./property-listing-steps.component.scss']
})
export class PropertyListingStepsComponent implements OnInit {

  pageNumber: number = 1;
  visitedPages: number[] = [1];
  loading: boolean = false;

  isProgressLockEnabled: boolean = true;

  tabNumberLeaflet: number = 1;
  sellerType: string | null = null;
  listingType: string | null = null;

  steps = [
    { label: 'Order Details', link: 1 },
    { label: 'Property Details', link: 2 },
    { label: 'Contract Details', link: 3 },
    { label: 'Upload Documents', link: 4 }
  ];

  tabLeaflet: any[] = [
    { id: 1, value: 'Step 1: Property Details' },
    { id: 2, value: 'Step 2: Upload documents' },
  ]

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _notificationService: NotificationService,
    private _mapStateCheckService: MapStateCheckService,
    private _sellMyPropertyService: SellMyPropertyService,
    private _propertyListingStateService: PropertyListingStateService
  ) { }

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      this.sellerType = params['sellerType'];
      this.listingType = params['listingType'];
    });

    if (this.listingType.toLocaleLowerCase() == "leaflet") {
      this.pageNumber = 2;
    }

    GlobalMethods.scrollToTop();
    window.addEventListener('beforeunload', this.confirmPageExit);
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.confirmPageExit);
  }

  confirmPageExit(event: BeforeUnloadEvent): string {
    event.preventDefault();
    return '';
  }

  unlockNextPage() {
    if (!this.visitedPages.includes(this.pageNumber + 1)) {
      this.visitedPages.push(this.pageNumber + 1);
    }
  }

  selectPage(pageNumber: number) {
    if (this.isProgressLockEnabled && !this.visitedPages.includes(pageNumber)) {
      this._snackBar.open('Please submit the form to proceed to the next step.', 'Close', {
        duration: 3000
      });
      return;
    }
    this.pageNumber = pageNumber;
    GlobalMethods.scrollToTop();
  }

  changePage(page: number) {
    if (this.isProgressLockEnabled && !this.visitedPages.includes(page)) {
      return;
    }
    if (this.listingType.toLocaleLowerCase() == "leaflet") {
      this.pageNumber = this.pageNumber + 2;
    } else {
      this.pageNumber = page;
    }
    GlobalMethods.scrollToTop();
  }

  onDocumentSubmitted(): void {
    this.createPropertyListing();
  }

  private createPropertyListing(): void {
    this.loading = true;
    this._propertyListingStateService.updateListingType(this.listingType);
    const formState: any = this._propertyListingStateService.getFormState();

    this._sellMyPropertyService.apiV1SellMyPropertySaveSellingMyPropertyFormPost({
      body: formState
    }).subscribe({
      next: () => {
        this.loading = false;
        this._propertyListingStateService.clearSelectedListing();
        this._router.navigateByUrl('');
        this._notificationService.showSuccessMessage('Success', 'Property created successfully.');
      },
      error: (_error: any) => {
        this.loading = false;
        this._notificationService.showErrorMessage('Error', 'An error occurred while creating a property.');
      }
    });
  }

  onFormSubmitted() {
    this.unlockNextPage();
    if (this.pageNumber == 1) {
      this._mapStateCheckService.updateMapState(true);
    }
  }
}
